import { ChevronRight } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconChevronRight(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ChevronRight />
    </IconWrapper>
  );
}
